export default "__VITE_ASSET__CHGX3uKi__"